import { useContext, useEffect, useState, useMemo } from "react";
import {
  getDetailCourse,
  getMyLearning,
} from "../../helpers/Course/getDetailCourse";
import { getTime } from "../../helpers/resource.helper";
import { getCompleted } from "../../helpers/tracking.helper";
import { TrackingContext } from "../../context/trackingContext";
import useContactRelation from "../contactRelation.hook";
import { getPurchase, getPurchaseQuery } from "../../helpers/Course/postPurchaseCourse";

export const useDetailCourse = (
  id,
  addComment,
  setaddComment,
  setShowModalError
) => {
  const { topicActiv } = useContext(TrackingContext);
  const {
    token: tokenUser,
    idContactRelation: idRelacionContacto,
    userLocal,
  } = useContactRelation();
  const [data, setData] = useState(undefined);
  const [duration, setDuration] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isCompleted, setIsCompleted] = useState(false);

  const body = useMemo(() => {
    return {
      id,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, idRelacionContacto]);
  
  useEffect(() => {
    async function fetchData() {
      if ((addComment == null || addComment) && idRelacionContacto && id) {
        const response = await getDetailCourse(
          tokenUser,
          // Q11-bis: pasamos `contactId` para que el backend enriquezca los
          // Adjuntos con `Completado`/`FechaCompletado` cuando el usuario ya
          // vio la lección. El frontend cruza esa marca con cada
          // `resource[i].Adjuntos.Id` para decidir el estado del temario.
          { id, idRelacionContacto, contactId: userLocal?.id },
          setShowModalError
        );
        setData(response);
        setIsLoading(false);
        setaddComment(false);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenUser, addComment, id, body, setShowModalError, idRelacionContacto, userLocal?.id]);

  useEffect(() => {
    async function getInfo() {
      if (data?.id && tokenUser && userLocal) {
        const response = await getTime(tokenUser, data.id);
        setDuration(response);
        const completed = await getCompleted(data.id, userLocal.id, tokenUser);
        setIsCompleted(completed.completed);
      }
    }
    getInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, tokenUser, topicActiv]);

  return {
    isLoading,
    data,
    duration,
    isCompleted,
  };
};

export const useMyLearning = (setShowModalError) => {
  const { token, idContactRelation, userLocal } = useContactRelation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [purchaseInfo, setPurchaseInfo] = useState([])

  const body = useMemo(() => {
    // Q11-ter: `contactId` opcional — si viene, el backend devuelve además
    // `progressPct`, `completed`, `completedLessons`, `totalLessons` y
    // `lastActivityAt` para cada curso.
    return {
      idContactRelation,
      contactId: userLocal?.id,
    };
  }, [idContactRelation, userLocal?.id]);

  useEffect(() => {
    (async () => {
      if (token && body.idContactRelation) {
        getMyLearning(token, body, setShowModalError).then((response) => {
          /* Antes había un switch que SOBRESCRIBÍA `course.thumbnail`
             para los ids 1-4 con paths RELATIVOS del CDN (sin dominio).
             El navegador los resolvía como relativos a la ruta actual
             (p. ej. `/89/64a5...jpeg`), 404, y la card salía sin
             portada. El backend ya construye la URL absoluta al CDN
             en `course.services.getMyLearning` → confiamos en ella y
             no la tocamos aquí. */
          setData(response);
          setIsLoading(false);
        });

        const response = await getPurchaseQuery(token, body.idContactRelation);
        setPurchaseInfo(response)
      }
    })();
  }, [token, body, setShowModalError]);

  const purchaseById = async (token, purchaseId) => {
    return await getPurchase(token, purchaseId);
  }

  return {
    isLoading,
    data,
    purchaseInfo,
    purchaseById
  };
};
